import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es.json';
import en from './locales/en.json';

const STORAGE_KEY = 'cth_locale';

// Normalise any detected/persisted value to one of our two supported tags.
// Avoids RangeErrors from Intl APIs when the browser exposes exotic tags
// like `en-US@posix` (seen in some headless envs).
const normalize = (raw) => {
  const v = (raw || '').toString().toLowerCase();
  return v.startsWith('en') ? 'en' : 'es';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnNull: false,
  });

// Force-normalise after detection so i18n.language is always 'es' or 'en'.
const detected = normalize(i18n.language);
if (detected !== i18n.language) {
  i18n.changeLanguage(detected);
}

export const setLocale = (lng) => {
  const safe = normalize(lng);
  localStorage.setItem(STORAGE_KEY, safe);
  i18n.changeLanguage(safe);
  return safe;
};

export const getLocale = () => normalize(i18n.language);

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = (lng || 'en').split('-')[0];
});

export default i18n;
